import TransferProviderList from "./TransferProviderList";
export default TransferProviderList;
